// V4-ACCOUNT-01 2026-05-29 — Mapper raw role/account_type vers label i18n
// Au lieu d'afficher "user" / "agency_owner" en raw, on traduit via i18n.

import type { TranslationKeys } from '../i18n/fr';

/**
 * Tous les codes connus côté backend pour role utilisateur / type de compte.
 * - UserRole (enum frontend) : "user" | "admin" | "viewer"
 * - Agency roles backend : "agency_owner" | "agency_admin" | "agency_member"
 * - Account types backend : "USER" | "AGENCY"
 */
export type AccountTypeRaw =
  | 'user'
  | 'admin'
  | 'viewer'
  | 'agency_owner'
  | 'agency_admin'
  | 'agency_member'
  | 'USER'
  | 'AGENCY'
  | string
  | null
  | undefined;

/**
 * Retourne le label i18n affichable pour un role / account_type donné.
 * Fallback : capitalize le raw (ex: "guest" → "Guest").
 */
export function getAccountTypeLabel(
  raw: AccountTypeRaw,
  t: TranslationKeys
): string {
  if (!raw) return t.account?.roleUser ?? 'Utilisateur';

  const account = t.account ?? ({} as TranslationKeys['account']);
  const key = String(raw).toLowerCase();

  switch (key) {
    case 'user':
      return account.roleUser ?? 'Utilisateur';
    case 'admin':
      return account.roleAdmin ?? 'Administrateur';
    case 'viewer':
      return account.roleViewer ?? 'Lecteur';
    case 'agency':
      return account.roleAgency ?? 'Agence';
    case 'agency_owner':
      return account.roleAgencyOwner ?? 'Propriétaire d\'agence';
    case 'agency_admin':
      return account.roleAgencyAdmin ?? 'Administrateur d\'agence';
    case 'agency_member':
      return account.roleAgencyMember ?? 'Membre d\'agence';
    default:
      // Fallback : capitalize 1st char
      return key.charAt(0).toUpperCase() + key.slice(1);
  }
}
